import React from 'react';

// Empty component that doesn't render anything
const BackToDemoButton: React.FC = () => {
  return null;
};

export default BackToDemoButton;